<template>
  <div class="search-result-container">
    <div v-if="categories" class="col-md-12 num-items">
      <p>{{trans.get('b2b.article.found-products')}} {{ categories.length }}</p>
      <a class="reset-filter" @click="resetFilter">{{trans.get('b2b.article.reset-filter')}}</a>
<!--      <ul v-if="searchTerms">-->
<!--        <li v-for="fam in searchTerms.family">{{ fam.descrizione }}</li>-->
<!--      </ul>-->
<!--      <ul v-if="searchTerms">-->
<!--        <li v-for="cat in searchTerms.category">{{cat.descrizione}}</li>-->
<!--      </ul>-->
<!--      <ul v-if="searchTerms">-->
<!--        <li v-for="col in searchTerms.color">{{col.descrizione}}</li>-->
<!--      </ul>-->
    </div>
    <div class="element col-md-6 col-lg-4 col-xl-3" v-for="cat in categories">
      <productcard
          class="product-card-search"
          :customer="true"
          :product="cat"
          :color="cat.cod_colore"
          :family="cat.family.codice"
          :categoria="true"/>
    </div>
  </div>
</template>

<script>
import productcard from "../product-card";

export default {
  components: {
    productcard
  },
  name: "search",
  props: {
    searchData: {
      type: Array
    }
  },
  data: function () {
    return {
      categories: null,
      isMounted: false,
      searchTerms: null,
    }
  },
  mounted() {
    this.fetchArticles()
    //this.getSearch();
  },

  methods: {
    resetFilter(){
      location.reload()
    },
    // getSearch() {
    //   axios({
    //     method: 'get',
    //     url: window.location.origin + '/data/get-family',
    //     params: {
    //       type: 'search-terms',
    //       card_code: this.searchData.cod_card
    //     }
    //   }).then(res=>{
    //     //console.log(res.data.family)
    //     this.searchTerms = res.data.family
    //   }).catch(err => {
    //     console.log(err.response.data.message)
    //   })
    // },
    fetchArticles: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/search",
        params: {
         cod_card: this.searchData
        },
      })
          .then((result) => {
            console.log(result.data)
            this.categories = result.data
            //console.log(this.categories)
          })
          .catch(err => {


            this.$store.commit('add_message', {
              type: 'error',
              message: err.response.data.message
            })

          })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-result-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: auto;
  max-width: 1200px;

  .product-card-search {
    margin: 0 13px 80px;
  }

  .num-items {
    margin-bottom: 20px;
    .reset-filter {
      text-decoration: underline;
    }
  }
}
</style>
